/**
 * Format state for Select2 display
 * @param {object} state - Select2 state object
 * @returns {string|jQuery} - Formatted state
 */
(function($) {
	function formatState(state) {
		if (!state.id) {
			return state.text;
		}

		var $state = $(
			'<span>' + state.text + '</span>'
		);

		if ($(state.element).hasClass('lock-option')) {
			$state = $(
				'<span><i class="lock-icon"></i> ' + state.text + '</span>'
			);
		}

		return $state;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = formatState;
	} else if (typeof window !== 'undefined') {
		window.formatState = formatState;
	}

})(jQuery);
